import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-300 overflow-hidden rounded-lg border border-background-300 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              aria-expanded={isOpen}
            >
              <span className="font-heading text-base font-semibold text-foreground-900">
                {item.q}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                  isOpen
                    ? 'border-primary-300 bg-primary-100 text-primary-700'
                    : 'border-background-300 text-foreground-500'
                }`}
              >
                <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-5">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}